module.exports = __webpack_public_path__ + "static/media/Base feature icon-2.42b98ff9.svg";